export default function getResource(label, vars = []) {
    const resources = {
        relatedSearchesTitle: 'Recherches connexes',
        searchForTerm: `Rechercher ${vars[0]}`,
        loadingRelatedSearches: 'Chargement des recherches connexes'
    };

    return resources[label];
}
